var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"9","height":"5","viewBox":"0 0 9 5","fill":"none"}},[_c('path',{class:_vm.light ? 'icon-color__fill--lighten5' : 'icon-color__fill--primary',attrs:{"d":"M0 4.75L4.5 0.25L9 4.75L0 4.75Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }